export default __webpack_public_path__ + "static/media/rhcommercial-logo.78936507.png";